var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/42px/Exit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9992 2.00096L16.9989 2.00095C16.4465 2.00095 15.9987 1.55313 15.9987 1.00077C15.9987 0.448398 16.4465 0.000623043 16.9989 0.000623091L18.9992 0.000623266C21.7597 0.00390605 23.9967 2.24095 24 5.00138L24 19.0036C23.9967 21.7641 21.7597 24.0011 18.9992 24.0044L16.9989 24.0044C16.4465 24.0044 15.9988 23.5566 15.9988 23.0042C15.9988 22.4519 16.4465 22.0041 16.9989 22.0041L18.9992 22.0041C20.6563 22.0041 21.9997 20.6607 21.9997 19.0036L21.9997 5.00143C21.9997 3.34432 20.6563 2.00096 18.9992 2.00096ZM5.04686 18.7106L1.16724 14.831L1.17123 14.831C-0.390563 13.2688 -0.390563 10.7364 1.17123 9.17411L5.05085 5.2945C5.05891 5.28615 5.06711 5.27795 5.07546 5.26988C5.47279 4.88615 6.10594 4.89717 6.48967 5.2945C6.8734 5.69183 6.86238 6.32497 6.46505 6.70871L2.58544 10.5883C2.45262 10.7256 2.3401 10.8812 2.2514 11.0504C2.26384 11.0495 2.27544 11.046 2.28706 11.0426C2.30067 11.0385 2.31432 11.0344 2.32942 11.0344L18.0099 11.0024C18.5623 11.0024 19.01 11.4502 19.01 12.0025C19.01 12.5549 18.5623 13.0027 18.0099 13.0027L2.32341 13.0347C2.31591 13.0347 2.30916 13.0327 2.30241 13.0307C2.29566 13.0287 2.28891 13.0267 2.28141 13.0267C2.36547 13.1682 2.46617 13.2992 2.58146 13.4167L6.46107 17.2964C6.83542 17.6839 6.83542 18.2984 6.46107 18.686C6.07734 19.0833 5.44419 19.0943 5.04686 18.7106Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExit);
export default __webpack_public_path__ + "static/media/ic_exit.e65348ba346cc55f769bc272c696f633.svg";
export { ForwardRef as ReactComponent };